import { render, staticRenderFns } from "./AddBusinessTableHis.vue?vue&type=template&id=cca0cc18&scoped=true"
import script from "./AddBusinessTableHis.vue?vue&type=script&lang=js"
export * from "./AddBusinessTableHis.vue?vue&type=script&lang=js"
import style0 from "./AddBusinessTableHis.vue?vue&type=style&index=0&id=cca0cc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca0cc18",
  null
  
)

export default component.exports